import { render, staticRenderFns } from "./info.vue?vue&type=template&id=27508ec0&scoped=true"
import script from "./info.vue?vue&type=script&lang=ts"
export * from "./info.vue?vue&type=script&lang=ts"
import style0 from "./info.vue?vue&type=style&index=0&id=27508ec0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27508ec0",
  null
  
)

export default component.exports